const FRACTION_DIGITS = 3;
const THOUSANDTHS = 10 ** FRACTION_DIGITS;

const NEGATIVE_SIGN = '-';

export const toThousandths = (amount: string): number => {
  const sign = amount.startsWith(NEGATIVE_SIGN) ? -1 : 1;
  const [integerPart = '0', fractionPart = ''] = amount.replace(NEGATIVE_SIGN, '').split('.');
  return sign * (Number(integerPart) * THOUSANDTHS + Number(fractionPart.padEnd(FRACTION_DIGITS, '0')));
};

export const fromThousandths = (units: number): string => {
  const magnitude = Math.abs(units);
  const whole = String(Math.trunc(magnitude / THOUSANDTHS));
  const fraction = String(magnitude % THOUSANDTHS).padStart(FRACTION_DIGITS, '0');
  return `${units < 0 ? '-' : ''}${whole}.${fraction}`;
};

export const subtractAmounts = (minuend: string, subtrahend: string): string =>
  fromThousandths(toThousandths(minuend) - toThousandths(subtrahend));

export const isSameAmount = (left: string, right: string): boolean =>
  toThousandths(left) === toThousandths(right);

export const isAmountAbove = (amount: string, floor: string): boolean =>
  toThousandths(amount) > toThousandths(floor);

export const amountShare = (part: string, whole: string): number =>
  toThousandths(part) / toThousandths(whole);

export const multiplyAmount = (amount: string, quantity: number): string =>
  fromThousandths(toThousandths(amount) * quantity);

export const sumAmounts = (amounts: readonly string[]): string =>
  fromThousandths(amounts.reduce((total, amount) => total + toThousandths(amount), 0));
